export default __webpack_public_path__ + "static/media/Collections-Logo__CryptoKitties.b22e2631.png";